import React from 'react'
import ReactDOM from 'react-dom'
import './fonts.css'
import App from './App'
import * as serviceWorker from './serviceWorker'
import "@mymoons/ui-library/dist/library.min.css"

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
)

serviceWorker.unregister()
